import { useTranslations } from '@vocab/react';
import { Box, Text } from 'braid-design-system';
import { useAtomValue } from 'jotai';

import type { UseCase } from '../../../entities/enums';
import translations from '../../../locales.vocab';
import { qrisDataAtom } from '../../../usecases/Qris/QrisStore';
import QRModal from '../../QRModal/QRModal';

interface Props {
  useCase: UseCase;
  onCloseDialog: (isExpiredFromModal: boolean) => void;
}

const QrisComponent = ({ useCase, onCloseDialog }: Props) => {
  const { t } = useTranslations(translations);
  const qrisData = useAtomValue(qrisDataAtom);

  const buttonText =
    useCase === 'CAJA'
      ? `"${t('pay.button.submit.caja')}"`
      : `"${t('pay.button.submit.invoice')}"`;

  return (
    <Box display="flex">
      <Text>
        {t('pay.option.idQRIS.description')} {buttonText}.
      </Text>

      {qrisData && (
        <QRModal
          id="qrDialog"
          url={qrisData?.qrImageUrl ?? ''}
          isModalOpen={qrisData !== undefined}
          expiry={qrisData?.qrExpiry ?? '5000'}
          paymentToken={qrisData?.paymentToken}
          onCloseDialog={onCloseDialog}
          paymentMethod="IdQr"
        />
      )}
    </Box>
  );
};

export default QrisComponent;
